import React from "react";
import SmartLockPermissionList from "../../components/event/SmartLockPermissionList";

const SmartLockPermissionsPage = () => {
    return <SmartLockPermissionList/>
}

export default SmartLockPermissionsPage;
